import moment from "moment"
export const checkDate = (date) => {
    if (date === null || date === "") {
        return "-"
    }
    return moment(date).format("DD/MM/YYYY")
}